import React from "react";
import * as S from "./Button.styles";

type Variant = "primary" | "outline";

type ButtonProps = {
    variant?: Variant;
    children?: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ variant = "primary", ...props }: ButtonProps) {
    return (
        <S.Container>
            <S.Button $variant={variant} {...props} />
        </S.Container>
    );
}
